module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/flash/flash-coupons/create-flash-coupon/create-flash-coupon.component.css
// module id = ./src/app/components/flash/flash-coupons/create-flash-coupon/create-flash-coupon.component.css
// module chunks = main